import i18n from 'i18next';
import { ALL } from './Components/constants';
import {
  PENDING_ACTIONS_FAILURE,
  PENDING_ACTIONS_REQUEST,
  PENDING_ACTIONS_SUCCESS,
  PENDING_ACTIONS_DM_REQUEST,
  PENDING_ACTIONS_DM_SUCCESS,
  PENDING_ACTIONS_DM_FAILURE,
  PENDING_ACTIONS_CIRA_REQUEST,
  PENDING_ACTIONS_CIRA_SUCCESS,
  PENDING_ACTIONS_CIRA_FAILURE,
  PENDING_ACTIONS_TIRA_REQUEST,
  PENDING_ACTIONS_TIRA_SUCCESS,
  PENDING_ACTIONS_TIRA_FAILURE,
  PENDING_ACTIONS_TATM_REQUEST,
  PENDING_ACTIONS_TATM_SUCCESS,
  PENDING_ACTIONS_TATM_FAILURE,
  PENDING_ACTIONS_ENTITY_REQUEST,
  PENDING_ACTIONS_ENTITY_SUCCESS,
  PENDING_ACTIONS_ENTITY_FAILURE,
  PENDING_ACTIONS_HCEOB_REQUEST,
  PENDING_ACTIONS_HCEOB_SUCCESS,
  PENDING_ACTIONS_HCEOB_FAILURE,
  DASHBOARD_FILTER_FAILURE,
  DASHBOARD_FILTER_REQUEST,
  DASHBOARD_FILTER_SUCCESS,
  ENTITIES_REQUEST,
  ENTITIES_SUCCESS,
  ENTITIES_FAILURE,
  EXPORT_REQUEST,
  EXPORT_SUCCESS,
  EXPORT_FAILURE,
  REPORTS_REQUEST,
  REPORTS_SUCCESS,
  REPORTS_FAILURE,
  TRANSACTION_DATA_REQUEST,
  TRANSACTION_DATA_SUCCESS,
  TRANSACTION_DATA_FAILURE,
  RESET_DASHBOARD_DATA
} from './actions';
import { sessionUser } from 'utility/sessionStorageHelper';
import { getTransactionSummaryData, getChartsData } from './Components/helper';
import { AMOUNT, COUNT } from './Components/constants';

import moment from 'moment';

const initialState = {
  pendingActions: null,
  filterFields: null,
  transactionData: null,
  topEntities: null
};

const pendingActionRequest = (state, action) => {
  return {
    ...state,
    loadingPA: true,
    pendingActionsTime: undefined,
    errorActionItems: null
  };
};

const pendingActionSuccess = (state, action) => {
  const { userDateFormat } = sessionUser.getLoggedInUser();
  const currentDateTime = new Date();

  const options = {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short'
  };
  const formatter = new Intl.DateTimeFormat('en-US', options);

  return {
    ...state,
    pendingActions: { ...action.response.data },
    pendingActionsTime: {
      date: moment(currentDateTime).format(userDateFormat.description),
      time: formatter.format(currentDateTime)
    },
    loadingPA: false,
    errorActionItems: null
  };
};

const pendingActionFailure = (state, action) => {
  return {
    ...state,
    loadingPA: false,
    pendingActionsTime: undefined,
    errorActionItems: action.error
  };
};

const pendingActionDMRequest = (state, action) => {
  return {
    ...state,
    loadingActionsDM: true,
    errorActionItems: null
  };
};
const pendingActionDMSuccess = (state, action) => {
  const { userDateFormat } = sessionUser.getLoggedInUser();
  const currentDateTime = new Date();
  const options = {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short'
  };
  const formatter = new Intl.DateTimeFormat('en-US', options);

  return {
    ...state,
    pendingActions: {
      ...state.pendingActions,
      decisionItems: action.response.data
    },
    pendingActionsTime: {
      date: moment(currentDateTime).format(userDateFormat.description),
      time: formatter.format(currentDateTime)
    },
    loadingActionsDM: false,
    errorActionItems: null
  };
};
const pendingActionDMFailure = (state, action) => {
  return {
    ...state,
    loadingActionsDM: false,
    errorActionItems: action.error
  };
};

const pendingActionCIRARequest = (state, action) => {
  return {
    ...state,
    loadingActionsCIRA: true,
    errorCira: null
  };
};
const pendingActionCIRASuccess = (state, action) => {
  const { userDateFormat } = sessionUser.getLoggedInUser();
  const currentDateTime = new Date();
  const options = {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short'
  };
  const formatter = new Intl.DateTimeFormat('en-US', options);
  return {
    ...state,
    pendingActions: {
      ...state.pendingActions,
      captureItems: action.response.data
    },
    pendingActionsTime: {
      date: moment(currentDateTime).format(userDateFormat.description),
      time: formatter.format(currentDateTime)
    },
    loadingActionsCIRA: false,
    errorCira: null
  };
};
const pendingActionCIRAFailure = (state, action) => {
  return {
    ...state,
    loadingActionsCIRA: false,
    errorCira: action.error
  };
};

const pendingActionTIRARequest = (state, action) => {
  return {
    ...state,
    loadingActionsTIRA: true,
    errorTira: null
  };
};
const pendingActionTIRASuccess = (state, action) => {
  const { userDateFormat } = sessionUser.getLoggedInUser();
  const currentDateTime = new Date();
  const options = {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short'
  };
  const formatter = new Intl.DateTimeFormat('en-US', options);
  return {
    ...state,
    pendingActions: {
      ...state.pendingActions,
      tira: action.response.data
    },
    pendingActionsTime: {
      date: moment(currentDateTime).format(userDateFormat.description),
      time: formatter.format(currentDateTime)
    },
    loadingActionsTIRA: false,
    errorTira: null
  };
};
const pendingActionTIRAFailure = (state, action) => {
  return {
    ...state,
    loadingActionsTIRA: false,
    errorTira: action.error
  };
};

const pendingActionTATMRequest = (state, action) => {
  return {
    ...state,
    loadingActionsTATM: true,
    errorTatm: null
  };
};
const pendingActionTATMSuccess = (state, action) => {
  const { userDateFormat } = sessionUser.getLoggedInUser();
  const currentDateTime = new Date();
  const options = {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short'
  };
  const formatter = new Intl.DateTimeFormat('en-US', options);
  return {
    ...state,
    pendingActions: {
      ...state.pendingActions,
      tatm: action.response.data
    },
    pendingActionsTime: {
      date: moment(currentDateTime).format(userDateFormat.description),
      time: formatter.format(currentDateTime)
    },
    loadingActionsTATM: false,
    errorTatm: null
  };
};
const pendingActionTATMFailure = (state, action) => {
  return {
    ...state,
    loadingActionsTATM: false,
    errorTatm: action.error
  };
};

const pendingActionEntityRequest = (state, action) => {
  return {
    ...state,
    loadingActionsEntity: true,
    errorActionItems: null
  };
};
const pendingActionEntitySuccess = (state, action) => {
  const { userDateFormat } = sessionUser.getLoggedInUser();
  const currentDateTime = new Date();
  const options = {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short'
  };
  const formatter = new Intl.DateTimeFormat('en-US', options);
  return {
    ...state,
    pendingActions: {
      ...state.pendingActions,
      entityItems: action.response.data
    },
    pendingActionsTime: {
      date: moment(currentDateTime).format(userDateFormat.description),
      time: formatter.format(currentDateTime)
    },
    loadingActionsEntity: false,
    errorActionItems: null
  };
};
const pendingActionEntityFailure = (state, action) => {
  return {
    ...state,
    loadingActionsEntity: false,
    errorActionItems: action.error
  };
};

const pendingActionHCEOBRequest = (state, action) => {
  return {
    ...state,
    loadingActionsHCEOB: true,
    errorActionItems: null
  };
};
const pendingActionHCEOBSuccess = (state, action) => {
  const { userDateFormat } = sessionUser.getLoggedInUser();
  const currentDateTime = new Date();
  const options = {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short'
  };
  const formatter = new Intl.DateTimeFormat('en-US', options);
  return {
    ...state,
    pendingActions: {
      ...state.pendingActions,
      hceobItems: action.response.data
    },
    pendingActionsTime: {
      date: moment(currentDateTime).format(userDateFormat.description),
      time: formatter.format(currentDateTime)
    },
    loadingActionsHCEOB: false,
    errorActionItems: null
  };
};
const pendingActionHCOEBFailure = (state, action) => {
  return {
    ...state,
    loadingActionsHCEOB: false,
    errorActionItems: action.error
  };
};

const filterRequest = (state, action) => {
  return {
    ...state,
    loadingFilter: true,
    error: null
  };
};

const mapFiltersResponse = data => {
  let filterFields = { ...data };
  filterFields.platformSource =
    data.platformSource.length > 0
      ? [
          { id: ALL, label: i18n.t('administration.labels.all') },
          ...data.platformSource.map(p => ({
            id: p.id,
            label: p.name
          }))
        ]
      : [];
  filterFields.programSource =
    data.programSource.length > 0
      ? [
          { id: ALL, label: i18n.t('administration.labels.all') },
          ...data.programSource.map(p => ({
            id: p.id,
            label: p.number + ' - ' + p.name
          }))
        ]
      : [];
  filterFields.ddaSource =
    data.ddaSource.length > 0
      ? [
          { id: ALL, label: i18n.t('administration.labels.all') },
          ...data.ddaSource.map(d => ({
            id: d.id,
            label: d.number
          }))
        ]
      : [];
  filterFields.methodSource =
    data.methodSource.length > 0
      ? [
          { id: ALL, label: i18n.t('administration.labels.all') },
          ...data.methodSource.map(m => ({
            id: m.id,
            label: m.description
          }))
        ]
      : [];
  filterFields.channelSource =
    data.channelSource.length > 0
      ? [
          { id: ALL, label: i18n.t('administration.labels.all') },
          ...data.channelSource.map(c => ({
            id: c.id,
            label: c.description
          }))
        ]
      : [];
  filterFields.entitySource =
    data.entitySource.length > 0
      ? [
          ...data.entitySource.map(e => ({
            id: e.id,
            label: e.name
          }))
        ]
      : [];
  filterFields.currencySource = [...data.currencySource.map(c => ({ id: c.id, label: c.name }))];

  return filterFields;
};
const filterSuccess = (state, action) => {
  return {
    ...state,
    filterFields: mapFiltersResponse(action.response.data),
    rawFields: action.response.data,
    loadingFilter: false,
    error: null
  };
};

const filterFailure = (state, action) => {
  return {
    ...state,
    loadingFilter: false,
    error: action.error
  };
};

const entitiesRequest = (state, action) => {
  return {
    ...state,
    loadingEntities: true,
    errorEntities: null
  };
};
const entitiesSuccess = (state, action) => {
  const amountArr = action.response.data
    ?.filter(item => item.dataType === AMOUNT)
    .sort((a, b) => {
      if (b.paymentAmount !== a.paymentAmount) {
        return b.paymentAmount - a.paymentAmount; // Primary sorting by paymentAmount
      }
      return b.paymentCount - a.paymentCount; // Secondary sorting by paymentCount
    });
  const countArr = action.response.data
    ?.filter(item => item.dataType === COUNT)
    .sort((a, b) => {
      if (b.paymentCount !== a.paymentCount) {
        return b.paymentCount - a.paymentCount; // Primary sorting by paymentCount
      }
      return b.paymentAmount - a.paymentAmount; // Secondary sorting by paymentAmount
    });

  return {
    ...state,
    entities: {
      amount: amountArr,
      count: countArr
    },
    loadingEntities: false,
    errorEntities: false
  };
};
const entitiesFailure = (state, action) => {
  return {
    ...state,
    loadingEntities: false,
    errorEntities: action.error
  };
};

const exportRequest = (state, action) => {
  return {
    ...state,
    pdfData: undefined,
    loadingExport: true,
    errorExport: null
  };
};

const exportSuccess = (state, action) => {
  return {
    ...state,
    pdfData: action.response.data,
    loadingExport: false,
    errorExport: null
  };
};
const exportFailure = (state, action) => {
  return {
    ...state,
    pdfData: undefined,
    loadingExport: false,
    errorExport: action.error
  };
};
const reportsRequest = (state, action) => {
  return {
    ...state,
    loadingReports: true,
    errorReports: null
  };
};
const reportsSuccess = (state, action) => {
  return {
    ...state,
    custReports: action.response.data.customReportDetails,
    loadingReports: false,
    errorReports: null
  };
};
const reportsFailure = (state, action) => {
  return {
    ...state,
    loadingReports: false,
    errorReports: action.error
  };
};

const transactionDataRequest = (state, action) => {
  return {
    ...state,
    loadingTransactionData: true,
    errorTransactionData: null
  };
};
const transactionDataSuccess = (state, action) => {
  const { userDateFormat } = sessionUser.getLoggedInUser();
  const currentDateTime = new Date();

  const options = {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short'
  };
  const formatter = new Intl.DateTimeFormat('en-US', options);
  const chartData = getChartsData(action.response.data);
  const transactionSummary = getTransactionSummaryData(action.response.data);

  return {
    ...state,
    transactionData: {
      chartData: chartData,
      transactionSummary: transactionSummary
    },
    transactionSummaryTime: {
      date: moment(currentDateTime).format(userDateFormat.description),
      time: formatter.format(currentDateTime)
    },
    loadingTransactionData: false,
    errorTransactionData: null
  };
};
const transactionDataFailure = (state, action) => {
  return {
    ...state,
    loadingTransactionData: false,
    errorTransactionData: action.error
  };
};

export default function dashboardReducer(state = {}, action) {
  const handlers = {
    [PENDING_ACTIONS_DM_REQUEST]: pendingActionDMRequest,
    [PENDING_ACTIONS_DM_SUCCESS]: pendingActionDMSuccess,
    [PENDING_ACTIONS_DM_FAILURE]: pendingActionDMFailure,
    [PENDING_ACTIONS_CIRA_REQUEST]: pendingActionCIRARequest,
    [PENDING_ACTIONS_CIRA_SUCCESS]: pendingActionCIRASuccess,
    [PENDING_ACTIONS_CIRA_FAILURE]: pendingActionCIRAFailure,
    [PENDING_ACTIONS_TIRA_REQUEST]: pendingActionTIRARequest,
    [PENDING_ACTIONS_TIRA_SUCCESS]: pendingActionTIRASuccess,
    [PENDING_ACTIONS_TIRA_FAILURE]: pendingActionTIRAFailure,
    [PENDING_ACTIONS_TATM_REQUEST]: pendingActionTATMRequest,
    [PENDING_ACTIONS_TATM_SUCCESS]: pendingActionTATMSuccess,
    [PENDING_ACTIONS_TATM_FAILURE]: pendingActionTATMFailure,
    [PENDING_ACTIONS_ENTITY_REQUEST]: pendingActionEntityRequest,
    [PENDING_ACTIONS_ENTITY_SUCCESS]: pendingActionEntitySuccess,
    [PENDING_ACTIONS_ENTITY_FAILURE]: pendingActionEntityFailure,
    [PENDING_ACTIONS_HCEOB_REQUEST]: pendingActionHCEOBRequest,
    [PENDING_ACTIONS_HCEOB_SUCCESS]: pendingActionHCEOBSuccess,
    [PENDING_ACTIONS_HCEOB_FAILURE]: pendingActionHCOEBFailure,
    [DASHBOARD_FILTER_REQUEST]: filterRequest,
    [DASHBOARD_FILTER_SUCCESS]: filterSuccess,
    [DASHBOARD_FILTER_FAILURE]: filterFailure,
    [ENTITIES_REQUEST]: entitiesRequest,
    [ENTITIES_SUCCESS]: entitiesSuccess,
    [ENTITIES_FAILURE]: entitiesFailure,
    [EXPORT_REQUEST]: exportRequest,
    [EXPORT_SUCCESS]: exportSuccess,
    [EXPORT_FAILURE]: exportFailure,
    [REPORTS_REQUEST]: reportsRequest,
    [REPORTS_SUCCESS]: reportsSuccess,
    [REPORTS_FAILURE]: reportsFailure,
    [TRANSACTION_DATA_REQUEST]: transactionDataRequest,
    [TRANSACTION_DATA_SUCCESS]: transactionDataSuccess,
    [TRANSACTION_DATA_FAILURE]: transactionDataFailure,
    [RESET_DASHBOARD_DATA]: () => initialState
  };
  if (handlers.hasOwnProperty(action.type)) {
    return handlers[action.type](state, action);
  } else {
    return state;
  }
}
